module.exports = __webpack_public_path__ + "static/dwarven_thrower-6a7e4a48150ef84fe7f655cd4c00f7b2.jpeg";